export default "/_next/static/fonts/tt_norms_pro_extralight-515a1378f9cc44949c2e071f63deffbb.woff";